/**
 * A category's address segment: "Laticínios" → "laticinios", "Grãos e cereais" → "graos-e-cereais".
 *
 * The catalogue answers category *names* (`/v1/catalog/categories`), with no id or slug of its own,
 * so the category page (`/catalogo/:categoria`, Figma D4) resolves a segment back to a name by
 * slugging every name it knows and matching — never by guessing the accents back.
 */
export function categorySlug(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/gu, '-')
    .replace(/^-+|-+$/gu, '');
}

/** The name among `names` whose slug is `slug`, or `undefined` when no category has it. */
export function categoryFromSlug(slug: string, names: readonly string[]): string | undefined {
  return names.find((name) => categorySlug(name) === slug);
}

/** Where a category's page lives. */
export function categoryHref(name: string): string {
  return `/catalogo/${categorySlug(name)}`;
}

/** Where a product's page lives (Figma D6: `produto/` keeps it apart from `/catalogo/:categoria`). */
export function productHref(skuId: string): string {
  return `/catalogo/produto/${encodeURIComponent(skuId)}`;
}
